<template>
  <div
    class="relative flex w-full cursor-pointer flex-nowrap items-center rounded-lg border-2 border-black-dark bg-white shadow-yellow-hard-md transition-all hover:translate-y-2 hover:shadow-none dark:bg-kekkle-dark-light dark:text-slate-200"
    @click="$router.push({ name: nextRoute })"
  >
    <Ping v-if="isNew" />
    <div class="flex h-16 w-16 shrink-0 items-center justify-center text-2xl">
      {{ emoji }}
    </div>
    <div class="pt-2 pr-2 pb-2">
      <p class="text-lg font-medium">{{ title }}</p>
      <p class="text-sm font-light italic">
        {{ description }}
      </p>
    </div>
  </div>
</template>
<script setup>
import Ping from "@/components/Ping.vue";

defineProps({
  nextRoute: { type: String, required: true },
  title: { type: String, required: true },
  description: { type: String, required: true },
  emoji: { type: String, required: true },
  isNew: { type: Boolean, default: false },
});
</script>
